import { Task } from "../../../models/Task/Task";
import { TTaskCatg } from "../../../models/Task/Types";
import createReducer from "../../utils/createReducer";
import ActionTypes from "./actionTypes";

export type TaskStateT = {
    tasks: { [k in TTaskCatg]: Task[] };
    loadingTasks: TTaskCatg | null;
    tasksLoaded: TTaskCatg[];
};

export const initialState: TaskStateT = {
    tasks: {
        user: [],
        active: [],
        assigned: [],
    },
    loadingTasks: null,
    tasksLoaded: [],
};

// App Reducer
export default createReducer<TaskStateT>(initialState, {
    [ActionTypes.SAVE_TASKS]: (state, payload: { [k in Partial<TTaskCatg>]: Task[] }) => ({
        ...state,
        tasks: { ...state.tasks, ...payload },
    }),
    [ActionTypes.LOADED_TASKS]: (state, payload: TTaskCatg) => ({
        ...state,
        tasksLoaded: [...state.tasksLoaded.filter((t) => t !== payload), payload],
    }),
    [ActionTypes.LOADING_TASKS]: (state, payload: TTaskCatg) => ({
        ...state,
        loadingTasks: payload,
    }),

    [ActionTypes.REMOVE_TASK]: (state, payload: Task) => ({
        ...state,
        tasks: Object.keys(state.tasks).reduce((curr, key) => {
            const filtered = state.tasks[key as TTaskCatg].filter((t) => t.id !== payload.id);
            curr[key as TTaskCatg] = filtered;
            return curr;
        }, {} as { [k in TTaskCatg]: Task[] }),
    }),
    [ActionTypes.LOGOUT_ACTION]: (state) => ({
        ...state,
        ...initialState,
    }),
});
